import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import "../../styles/art/HeroSection.css";

const heroSlides = [
  { image: "/images/art/art-slider1.jpg" },
  { image: "/images/art/art-slider2.jpg" },
];

function HeroSection() {
  return (
    <section className="hero-section">
      <Swiper
        modules={[Autoplay, EffectFade, Pagination]}
        autoplay={{ delay: 6000, disableOnInteraction: false }}
        effect="fade"
        loop
        pagination={{ clickable: true }}
        className="hero-section__swiper"
      >
        {heroSlides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div
              className="hero-section__slide"
              style={{ backgroundImage: `url(${slide.image})` }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}

export default HeroSection;
